import React from 'react'
import { Nav, Navbar, NavItem } from 'react-bootstrap'
import { Route } from 'react-router-dom';
import { LinkContainer } from 'react-router-bootstrap'

import About from './About'
import TennisPrograms from './TennisPrograms'
import TennisSchool from './TennisSchool'
import Coaches from './Coaches'
import Gallery from './Gallery'
import Location from './Location'

const MainSection = (props) => {
    return (
        <div>
            <Navbar className="navbar-default">
                <div className="container">
                    <Navbar.Header>
                        <Navbar.Brand>
                            <a href="/">TK Vamos</a>
                        </Navbar.Brand>
                        <Navbar.Toggle />
                    </Navbar.Header>
                    <Navbar.Collapse>
                    <Nav>
                        <LinkContainer to="/onama"><NavItem eventKey={0}>O nama</NavItem></LinkContainer>
                        <LinkContainer to="/programi-tenisa"><NavItem eventKey={1}>Programi</NavItem></LinkContainer>
                        <LinkContainer to="/skola-tenisa"><NavItem eventKey={3}>Škola</NavItem></LinkContainer>
                        <LinkContainer to="/treneri"><NavItem eventKey={4}>Treneri</NavItem></LinkContainer>
                        <LinkContainer to="/galerija"><NavItem eventKey={5}>Galerija</NavItem></LinkContainer>
                        <LinkContainer to="/lokacija"><NavItem eventKey={6}>Lokacija</NavItem></LinkContainer>
                    </Nav>
                    </Navbar.Collapse>
                </div>
            </Navbar>

            <Route exact path="/" component={About}/>
            <Route path="/home" component={About}/>
            <Route path="/onama" component={About}/>
            <Route path="/programi-tenisa" component={TennisPrograms}/>
            <Route path="/skola-tenisa" component={TennisSchool}/>
            <Route path="/treneri" component={Coaches}/>
            <Route path="/galerija" component={Gallery}/>
            <Route path="/lokacija" component={Location}/>
        </div>
    );
}

export default MainSection



// WEBPACK FOOTER //
// ./src/components/MainSection.js